
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"13","height":"13","rx":"2","fill":"#1C2F45"}}),_c('path',{attrs:{"d":"M8.226 5L5.875 7.435 4.774 6.38 4 7.163 5.875 9 9 5.782 8.226 5z","fill":"#fff"}})])
          )
        }
      }
    